/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsuranceUserCarrierView } from '../models/InsuranceUserCarrierView';
import type { Insurer } from '../models/Insurer';
import type { InsurerSort } from '../models/InsurerSort';
import type { InsurerStatus } from '../models/InsurerStatus';
import type { ListInsuranceUsersResult } from '../models/ListInsuranceUsersResult';
import type { ListInsurersResult } from '../models/ListInsurersResult';
import type { SortDirection } from '../models/SortDirection';
import type { UserSort } from '../models/UserSort';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsurersService {
  /**
   * Verify whether the license number exists in the insurers
   * @param licenseNumber
   * @returns Insurer OK
   * @throws ApiError
   */
  public static verifyLicenseNumberAsync(
    licenseNumber?: number,
  ): CancelablePromise<Insurer> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers/validate',
      query: {
        'licenseNumber': licenseNumber,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Get user's Insurers
   * @returns Insurer OK
   * @throws ApiError
   */
  public static getUserInsurersAsync(): CancelablePromise<Array<Insurer>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * List all insurers with optional search and pagination
   * @param query
   * @param status
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns ListInsurersResult OK
   * @throws ApiError
   */
  public static listInsurers(
    query?: string,
    status?: InsurerStatus,
    limit?: number,
    offset?: number,
    sortBy?: InsurerSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<ListInsurersResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers/list',
      query: {
        'query': query,
        'status': status,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Get insurer details by TDI license number
   * @param licenseNumber
   * @returns Insurer OK
   * @throws ApiError
   */
  public static getInsurer(
    licenseNumber: number,
  ): CancelablePromise<Insurer> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers/{licenseNumber}',
      path: {
        'licenseNumber': licenseNumber,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * List users associated with a specific insurer
   * @param licenseNumber
   * @param query
   * @param enabled
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns ListInsuranceUsersResult OK
   * @throws ApiError
   */
  public static listInsurerUsersAsync(
    licenseNumber: number,
    query?: string,
    enabled?: boolean,
    limit?: number,
    offset?: number,
    sortBy?: UserSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<ListInsuranceUsersResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers/{licenseNumber}/users',
      path: {
        'licenseNumber': licenseNumber,
      },
      query: {
        'query': query,
        'enabled': enabled,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * List motor carriers that have had insurance policies filed through this insurer
   * @param licenseNumber
   * @returns InsuranceUserCarrierView OK
   * @throws ApiError
   */
  public static getInsurerCompanies(
    licenseNumber: number,
  ): CancelablePromise<Array<InsuranceUserCarrierView>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Insurers/{licenseNumber}/companies',
      path: {
        'licenseNumber': licenseNumber,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
}
